import React, { useEffect } from 'react';
import { useFieldArray, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Textarea } from 'components/form';
import * as yup from 'yup';
import { BaseEditModal } from '../base-edit-modal';

type QualificationFormData = {
  qualifications: {
    description: string;
  }[];
};

const qualificationSchema = yup.object().shape({
  qualifications: yup.array().of(
    yup.object().shape({
      description: yup.string().required('Description is required'),
    })
  ).required('At least one qualification is required').min(1, 'At least one qualification is required'),
});

interface JdQualificationsEditModalProps {
  isOpen: boolean;
  onClose: () => void;
  currentData: QualificationFormData;
  onSave: (data: QualificationFormData) => void;
  isSubmitting?: boolean;
  title?: string;
}

export const JdQualificationsEditModal: React.FC<JdQualificationsEditModalProps> = ({
  isOpen,
  onClose,
  currentData,
  onSave,
  isSubmitting,
  title = "Qualifications",
}) => {
  const defaultValues: QualificationFormData = currentData || { qualifications: [] };

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    reset,
  } = useForm<QualificationFormData>({
    defaultValues,
    resolver: yupResolver(qualificationSchema),
  });

  const { fields } = useFieldArray({
    control,
    name: 'qualifications',
  });

  useEffect(() => {
    reset(defaultValues);
  }, [currentData, reset]);

  const onSubmit = (data: QualificationFormData) => {
    onSave(data);
  };

  return (
    <BaseEditModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      onSubmit={handleSubmit(onSubmit)}
      isSubmitting={isSubmitting}
      contentClassName="!bg-white"
      saveButtonText="Update"
    >
      <div className="font-[Gelion] w-[88%] mx-auto bg-white rounded-lg py-4">
        <h3 className="text-lg font-semibold text-[#1D2939] mb-5">Qualification</h3>
        {fields.map((item, index) => (
          <div
            key={item.id}
            className="[&_label]:text-[#667085] [&_label]:text-sm [&_label]:font-medium"
          >
            <div>
              <Textarea
                placeholder=''
                required
                validatorMessage={errors.qualifications?.[index]?.description?.message ?? ""}
                name={`qualifications.${index}.description`}
                register={register}
                className="!border !border-[#01216980] !mb-0 !rounded-md !bg-white !h-[45px] !min-h-[45px]"
                parentClassName="!mb-4"
              />
            </div>
          </div>
        ))}
      </div>
    </BaseEditModal>
  );
};
